import KAMPYLE_DATA from "./KAMPYLE_DATA";
import KAMPYLE_ONSITE_SDK from "./KAMPYLE_ONSITE_SDK";

	function Logger() {
    var LOG_TYPES = {
      DEBUG:'log',
      INFO:'info',
      WARN:'warn',
      ERROR:'warn'
    };
    this._logs = [];

    this.init = function(){
      if (!this.getLoggerStatus()) {
        KAMPYLE_ONSITE_SDK.stopLogger();
      }
    }
    this.getLoggerStatus = function(){
      var currentLoggerStatus = KAMPYLE_DATA.getData('mdLogger');
      return currentLoggerStatus === 'true' || currentLoggerStatus === true;
    };
    this.setLoggerStatus = function(status){
      KAMPYLE_DATA.setData('mdLogger',status);
    }
    this.debug = function(message){
      this.writeLog('DEBUG',message);
    }
    this.warn = function(message){
      this.writeLog('WARN',message);
    }
    this.error = function(message){
      this.writeLog('ERROR',message);
    }
    this.writeLog = function(logLevel,message){
      var logType = LOG_TYPES[logLevel] || LOG_TYPES.DEBUG;
      message = this.setTimeAndLevelOnMessage(logLevel,message);
      this._logs.push({
        type: logType,
        message: message || "",
      });
    };
    this.setTimeAndLevelOnMessage = function(logLevel,message){
      return new Date() + ' ' + '[' + logLevel + '] ' + message;
    };
    this.printLogs = function(){
      var str = "";
      this._logs.forEach(function(log){
        console[log.type](log.message);
        str += " " + log.message;
      });
      return str;
    };
  }

	export default new Logger();


